import { useEffect, useState } from "react";
import { InstallPromptContext } from "./InstallPromptContext";
import { isIOS, isAndroid, isInStandaloneMode } from "./detectPlatform";

const STORAGE_KEY = "pwa-install-dismissed-at";

export default function InstallPromptProvider({ children }) {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallUI, setShowInstallUI] = useState(false);

  useEffect(() => {
    console.log("[PWA Install] Iniciando verificação de instalação...");
    
    const isStandalone = isInStandaloneMode();
    const isIOSDevice = isIOS();
    
    console.log("[PWA Install] Standalone mode:", isStandalone);
    console.log("[PWA Install] iOS device:", isIOSDevice);
    
    if (isStandalone) {
      console.log("[PWA Install] App já está instalado, não mostrar prompt");
      return;
    }

    const lastDismiss = localStorage.getItem(STORAGE_KEY);
    if (lastDismiss) {
      const diff = Date.now() - Number(lastDismiss);
      const daysSinceDismiss = diff / (1000 * 60 * 60 * 24);
      console.log("[PWA Install] Última vez que foi dispensado:", daysSinceDismiss.toFixed(1), "dias atrás");
      
      if (diff < 1000 * 60 * 60 * 24 * 15) {
        console.log("[PWA Install] Ainda dentro do período de 15 dias, não mostrar");
        return;
      }
    }

    const handleBeforeInstallPrompt = (e) => {
      console.log("[PWA Install] Evento beforeinstallprompt capturado!", e);
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallUI(true);
      console.log("[PWA Install] showInstallUI definido como true");
    };

    // Verificar se o evento já foi disparado antes do listener ser adicionado
    // Isso pode acontecer se o script carregar depois do evento
    if (window.deferredPrompt) {
      console.log("[PWA Install] deferredPrompt já existe no window");
      setDeferredPrompt(window.deferredPrompt);
      setShowInstallUI(true);
    }

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    console.log("[PWA Install] Listener de beforeinstallprompt adicionado");

    // Para iOS, mostrar sempre (não depende do evento)
    if (isIOSDevice) {
      console.log("[PWA Install] Dispositivo iOS detectado, mostrando instruções");
      setShowInstallUI(true);
    } else if (isAndroid()) {
      // Para Android, mostrar a barra mesmo sem o evento
      // O evento pode não ser disparado, mas ainda podemos mostrar instruções
      console.log("[PWA Install] Dispositivo Android detectado");
      // Aguardar um pouco para ver se o evento é disparado primeiro
      const timeoutId = setTimeout(() => {
        console.log("[PWA Install] Timeout: mostrando barra mesmo sem evento");
        setShowInstallUI(true);
      }, 1000);
      
      return () => {
        clearTimeout(timeoutId);
        console.log("[PWA Install] Limpando listeners");
        window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      };
    }

    return () => {
      console.log("[PWA Install] Limpando listeners");
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, Date.now().toString());
    setShowInstallUI(false);
  };

  return (
    <InstallPromptContext.Provider
      value={{
        deferredPrompt,
        setDeferredPrompt,
        showInstallUI,
        setShowInstallUI,
        dismiss,
      }}
    >
      {children}
    </InstallPromptContext.Provider>
  );
}
